import { Injector } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { DevelopmentProduct } from "../../../Data/Art57Data/DevelopmentProduct";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { TreeNodeDrugsATCList } from "../ListEntity/TreeNodeDrugsATCList";
import { TreeNodeDrugsIndicationsList } from "../ListEntity/TreeNodeDrugsIndicationsList";
import { TreeNodePharmaceuticalProductsList } from "../ListEntity/TreeNodePharmaceuticalProductsList";
import { TreeNodeProductAttachmentList } from "../ListEntity/TreeNodeProductAttachmentList";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeDevelopmentProduct extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new DevelopmentProduct(
          new FieldDefinition(injector),
          new FormGroup({}),
          {}
        ),
        '{param1} - Development {param2} '
      );
  
      this.parent = parent;
      this.labelNodeName = 'Development Product';
      this.expanded = true;
      this.data.model.operationtype = 1; // Insert Operation
    // localnumber is calculated in createchiltemplate of its parent because requires nodetype
    this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();

    }
  
    override refreshLabel(): void {
      if (
        this.data &&
        this.data.model &&
        this.data.model.developmentpresentationname &&
        this.data.model.developmentpresentationname.productname
      ) {
        this.label =
          this.labelTemplate +
          ' - ' +
          this.data.model.developmentpresentationname.productname;
      } else {
        this.label = this.labelTemplate;
      }
      const param2 = this.data.model && this.data.model.operationtype && this.data.model.operationtype === 1?'':'- ' + this.data.model.ev_Code;
      this.label = this.label.replace('{param1}',this.ioc!.get(LookupGetService).retrieveValueFromCache('operationtype',this.data.model.operationtype)).replace('{param2}',param2);
    }
  
    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.ev_Code
          ? this.data.model.ev_Code
          : '-',
        this.data.model &&
        this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'operationtype',
          this.data.model.operationtype
        ),
        'Development',
        this.data.model &&
          this.data.model.developmentpresentationname &&
          this.data.model.developmentpresentationname.productname
          ? this.data.model.developmentpresentationname.productname
          : '',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeDevelopmentProduct = new TreeNodeDevelopmentProduct(
        this.ioc!,
        newParent
      );
  
      const currentLocalNumber = this.ioc!.get(LookupGetService).getNodeLocalNumber(clonedNode, this);
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.data.model.localnumber = currentLocalNumber;
      this.ioc!.get(LookupGetService).fixLocalNumber(clonedNode.data.model.localnumber);
       
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
   
    override setMessage(jsonObject: any): void {

      super.setMessage(jsonObject);

      if (jsonObject.pharmaceuticalproducts) {
        Art57NodeUtils.importNodeType(this,jsonObject.pharmaceuticalproducts,'pharmaceuticalproduct',TreeNodePharmaceuticalProductsList);
      }

      if (jsonObject.productatcs) {
        Art57NodeUtils.importNodeType(this,jsonObject.productatcs,'productatc',TreeNodeDrugsATCList);    
      }

      if (jsonObject.productindications) {
        Art57NodeUtils.importNodeType(this,jsonObject.productindications,'productindication',TreeNodeDrugsIndicationsList);    
      }
 
      if (jsonObject.ppiattachments) {
        Art57NodeUtils.importNodeType(this,jsonObject.ppiattachments,'ppiattachment',TreeNodeProductAttachmentList,{ nodeTypeToCreateName: '', nodeType: 1 });    
      }
      
      this.refreshLabel();
        
    }

    override validateBusinessRules(): any[] {
      const sameReferenceBychildBusinessRulesErrors = ErrorControlUtil.sameReferenceByChild(this, "developmentpresentationname", "productname");

      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];
      
      if (sameReferenceBychildBusinessRulesErrors.length>0) {
        businessRulesErrors.push(...sameReferenceBychildBusinessRulesErrors);
      }

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
  }    
  }